import { configureStore } from "@reduxjs/toolkit";

import appBasicSettingsReducer from "./slices/appBasicSettingsSlice";
import appUpdateReducer from "./slices/appUpdateSlice";
import authReducer from "./slices/authSlice";
import branchesReducer from "./slices/branchesSlice";
import employeesReducer from "./slices/employeesSlice";
import faqsReducer from "./slices/faqsSlice";
import inquiriesReducer from "./slices/inquiriesSlice";
import membersReducer from "./slices/membersSlice";
import noticesReducer from "./slices/noticesSlice";
import ownerCertificationsReducer from "./slices/ownerCertificationsSlice";
import policiesReducer from "./slices/policiesSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    members: membersReducer,
    branches: branchesReducer,
    employees: employeesReducer,
    ownerCertifications: ownerCertificationsReducer,
    notices: noticesReducer,
    faqs: faqsReducer,
    policies: policiesReducer,
    inquiries: inquiriesReducer,
    appUpdate: appUpdateReducer,
    appBasicSettings: appBasicSettingsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
